import React, { forwardRef } from "react";
import PropTypes from 'prop-types';
import { TableRow, TableCell, IconButton } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';

const correctAddress = (city, street) => {
    if(city !== '' && street !== ''){
        return city + ', ' + street;
    }

    if(city !== '' && street === ''){
        return city;
    }

    if(street !== '' && city === ''){
        return street;
    }

    return '';
};

const ClientRow = forwardRef(({ data, classes, onClientsManageClick}, ref) => {
    return (
        <TableRow ref={ref}>
                <TableCell className={classes.cell}>
                    {data.klient_nazwa}
                </TableCell>
                <TableCell className={classes.cell}>
                    {data.klient_rodzaj}
                </TableCell>
                <TableCell className={classes.cell}>
                    {correctAddress(data.klient_miasto, data.klient_ulica)}
                </TableCell>
                <TableCell className={classes.cell}>
                    {data.klient_nip}
                </TableCell>
                <TableCell className={classes.cell}>
                    <IconButton onClick={() => onClientsManageClick(data.klient_id)}>
                        <ListIcon />
                    </IconButton>
                </TableCell>
        </TableRow>
    );
});

ClientRow.displayName = "ClientRow";

ClientRow.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    onClientsManageClick: PropTypes.func
};


export default ClientRow;